import getLocalString from "constants/Localization";
import {
  GetOrganizationEmailIdentityDocument,
  SesVerificationStatus,
  useRefreshOrganizationEmailIdentityStatusMutation,
} from "generated/graphql";
import useGlobalMessage from "hooks/notifications/useGlobalMessage";
import { useCallback } from "react";

export default function useRefreshOrganizationEmailIdentityStatus() {
  const { show } = useGlobalMessage();
  const [refresh, { loading }] = useRefreshOrganizationEmailIdentityStatusMutation({
    refetchQueries: [{ query: GetOrganizationEmailIdentityDocument }],
  });

  const handleRefresh = useCallback(async () => {
    try {
      const result = await refresh();
      const status = result.data?.refreshOrganizationEmailIdentityStatus?.verificationStatus;
      if (status === SesVerificationStatus.VERIFIED) {
        show({
          message: getLocalString("emailIdentity.refresh-verified"),
          options: { variant: "success" },
        });
      } else {
        show({
          message: getLocalString("emailIdentity.refresh-pending"),
          options: { variant: "info" },
        });
      }
    } catch {
      show({
        message: getLocalString("emailIdentity.refresh-failure"),
        options: { variant: "error" },
      });
    }
  }, [refresh, show]);

  return [handleRefresh, { loading }] as const;
}
